import type { ProviderConfig } from "../schema/provider.js";
import type { TelemetryRuntime } from "../core/types.js";

export type ProviderRuntimeScope = "client" | "server" | "both";

export function getProviderRuntimeScope(
  config: ProviderConfig,
): ProviderRuntimeScope {
  return config.runtime ?? "both";
}

export function providerMatchesRuntime(
  config: ProviderConfig,
  active: TelemetryRuntime,
): boolean {
  const scope = getProviderRuntimeScope(config);
  if (scope === "both") return true;
  return scope === active;
}
